var exports = {
  "e6": "ChannelItem.module__channelItemCore___SWlHd2",
  "$H": "ChannelItem.module__channelItemCoreSelected___SWlHd2",
  "_B": "ChannelItem.module__channelItemCoreUnselected___SWlHd2",
  "Vp": "ChannelItem.module__channelItemCoreHovered___SWlHd2",
  "TV": "ChannelItem.module__typingTooltip___SWlHd2",
  "kp": "ChannelItem.module__channelTypingIndicator___SWlHd2",
  "IM": "ChannelItem.module__typingIndicatorIcon___SWlHd2",
  "U4": "ChannelItem.module__channelItemSelected___SWlHd2",
  "OI": "ChannelItem.module__typingAvatars___SWlHd2",
  "_N": "ChannelItem.module__channelItemIcon___SWlHd2",
  "Jz": "ChannelItem.module__channelItemIconSelected___SWlHd2",
  "Wk": "ChannelItem.module__categoryContainer___SWlHd2",
  "yb": "ChannelItem.module__categoryName___SWlHd2",
  "zc": "ChannelItem.module__iconContainer___SWlHd2",
  "HA": "ChannelItem.module__channelName___SWlHd2",
  "Hq": "ChannelItem.module__actionsContainer___SWlHd2",
  "OO": "ChannelItem.module__channelItemIconUnselected___SWlHd2",
  "Cr": "ChannelItem.module__channelItemIconHighlight___SWlHd2",
  "rC": "ChannelItem.module__channelItemLabel___SWlHd2",
  "gw": "ChannelItem.module__channelItemActions___SWlHd2",
  "kL": "ChannelItem.module__container___SWlHd2",
  "YI": "ChannelItem.module__channelReorderTarget___SWlHd2",
  "c2": "ChannelItem.module__channelCategoryReorderTarget___SWlHd2",
  "XE": "ChannelItem.module__unreadIndicator___SWlHd2",
  "_j": "ChannelItem.module__unreadIndicatorMuted___SWlHd2",
  "fc": "ChannelItem.module__channelItem___SWlHd2",
  "Z$": "ChannelItem.module__channelItemCategory___SWlHd2",
  "RQ": "ChannelItem.module__channelItemRegular___SWlHd2",
  "zx": "ChannelItem.module__channelItemHighlight___SWlHd2",
  "_R": "ChannelItem.module__channelItemMuted___SWlHd2",
  "Td": "ChannelItem.module__channelItemSelectedWithUnread___SWlHd2",
  "Fb": "ChannelItem.module__channelItemHoverable___SWlHd2",
  "FN": "ChannelItem.module__channelItemPressed___SWlHd2",
  "Je": "ChannelItem.module__channelItemOver___SWlHd2",
  "X9": "ChannelItem.module__channelItemContextMenu___SWlHd2",
  "L5": "ChannelItem.module__channelItemCategoryContextMenu___SWlHd2",
  "GJ": "ChannelItem.module__channelItemDragging___SWlHd2",
  "rO": "ChannelItem.module__channelItemDimmed___SWlHd2",
  "x1": "ChannelItem.module__channelItemMutedState___SWlHd2",
  "Ef": "ChannelItem.module__hoverAffordance___SWlHd2",
  "Mn": "ChannelItem.module__keyboardFocus___SWlHd2",
  "BE": "ChannelItem.module__channelItemAutocompleteHighlight___SWlHd2",
  "Yq": "ChannelItem.module__categoryContent___SWlHd2",
  "Yl": "ChannelItem.module__categoryIcon___SWlHd2",
  "Sk": "ChannelItem.module__createChannelButton___SWlHd2",
  "$Z": "ChannelItem.module__createChannelIcon___SWlHd2",
  "Ne": "ChannelItem.module__voiceUserCount___SWlHd2",
  "p9": "ChannelItem.module__channelItemVoice___SWlHd2",
  "pL": "ChannelItem.module__contextMenuOpen___SWlHd2",
  "jL": "ChannelItem.module__channelItemHoverAffordancesActive___SWlHd2",
};

module.exports = exports;
